import React from "react";
import { GeneralObject } from "../../../definitions/general";
import Icon from "../Icon";
import { GenericImageCarousel } from "../ImageCarousel";
import Portal from "../Portal";

interface ImageSlideshowProps {
  images: string[];
  close: () => void;
  carouselProps: GeneralObject;
}

const ImageSlideshow: React.FC<ImageSlideshowProps> = ({
  images,
  close,
  carouselProps,
}) => {
  return (
    <Portal>
      <section className="bg-black w-full h-screen overflow-hidden fixed top-0 left-0 z-90 p-4">
        <button
          className="fixed right-0 top-0 m-4 z-50 text-white leading-none focus:outline-none"
          onClick={close}
        >
          <Icon className="text-xl sm:text-3xl">close</Icon>
        </button>
        <GenericImageCarousel
          images={images}
          isSlideshow
          imageFit="contain"
          showTitle
          carouselProps={carouselProps}
        />
      </section>
    </Portal>
  );
};

export default ImageSlideshow;
